import { removeOverlay } from "../ui/common/utils";
import $ from "jquery";

export function addBlankLinesToYAxis(axis) {
	// CHA-4831 Two additional horizontal lines should be added to y-axe scale, so we can place watermark in it
	let ticksContainDecimals = false;

	let currentTicks = axis.ticks.filter((tick) => {
		const tickIsInteger = Number.isInteger(tick.value);
		if (!tickIsInteger) {
			ticksContainDecimals = true;
		}

		return tickIsInteger;
	});

	const stepSize = currentTicks[1].value - currentTicks[0].value;
	const buildTick = (currentTicks) => ({
		value: currentTicks.at(-1).value + stepSize,
		label: currentTicks.at(-1).value + stepSize,
	});

	if (ticksContainDecimals) {
		currentTicks.push(buildTick(currentTicks));
	} else {
		currentTicks.push(buildTick(currentTicks));
		currentTicks.push(buildTick(currentTicks));
	}

	axis.ticks = currentTicks;
	axis.max = currentTicks.at(-1).value;
}

export function drillDownChart(e, chart, chartCategory, uniqueVariantsCount) {
	if (uniqueVariantsCount < 50) {
		return;
	}

	const points = chart.getElementsAtEventForMode(
		e,
		"nearest",
		{
			intersect: true,
		},
		true,
	);

	if (points.length === 1 && chartCategory !== null) {
		const firstPoint = points[0];
		const dataset = chart.data.datasets[firstPoint.datasetIndex];

		const marketGroup = dataset.label;
		const year = chart.data.labels[firstPoint.index];
		const lastPathFragment = window.location.href.split("/").pop();
		const chCode = lastPathFragment.substring(
			0,
			lastPathFragment.indexOf("#"),
		);
		$.get(
			`/api/v1/charts-category/${chartCategory}/${chCode}/${marketGroup}/${year}`,
		).done((html) => {
			$(".section--content").append(html);
		});
	}
}

export function initShowHideAll(multipleSelectionButtonId, chart) {
	if (!multipleSelectionButtonId) {
		return;
	}

	const multipleSelectionButton = document.getElementById(
		multipleSelectionButtonId,
	);

	multipleSelectionButton?.addEventListener("click", () => {
		const hidden = multipleSelectionButton.hasAttribute("data-hidden");
		chart.data.datasets.forEach((dataset, i) => {
			chart.getDatasetMeta(i).hidden = !hidden;
		});
		chart.update("none");
		hidden
			? multipleSelectionButton.removeAttribute("data-hidden")
			: multipleSelectionButton.setAttribute("data-hidden", "");
	});
}

function showChartDisclaimerText(spinnerId, disclaimerId) {
	const loadingSpinner = document.querySelector(spinnerId);
	const mutationCallback = (mutationsList) => {
		for (const mutation of mutationsList) {
			if (
				mutation.type === "attributes" &&
				mutation.attributeName === "class" &&
				loadingSpinner.classList.contains("loaded")
			) {
				const hiddenDisclaimer = document.querySelector(disclaimerId);
				hiddenDisclaimer?.classList.remove("hide");
			}
		}
	};
	new MutationObserver(mutationCallback).observe(loadingSpinner, {
		attributes: true,
	});
}

export function prepareForPrint(imgElementId, chart) {
	if (!imgElementId || !chart) {
		return;
	}

	const image = $(`#${imgElementId}`);
	image.attr("src", chart.toBase64Image());
	image.addClass("chart-image-loaded");
}

function deleteOpenedChart(id) {
	$(`#${id}`).remove();
	removeOverlay();
}

window.deleteOpenedChart = deleteOpenedChart;
window.showChartDisclaimerText = showChartDisclaimerText;
